<template>
  <nav ref="nav" id="nav" class="nav"
       :class="{active:$Store.Public().scroll.y<=80||$Store.Public().scroll.dY==='top'}">
    <div class="container">
      <img class="logo" alt="logo"
           :src="file.ImageLogo">
      <div v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.XL)" class="button_menu"
           @click="$Store.Page().updateMenu({isOpen:!$Store.Page().menu.isOpen})">
        <MenuOutlined :class="!$Store.Page().menu.isOpen?'active':''" />
        <CloseOutlined :class="$Store.Page().menu.isOpen?'active':''" />
      </div>
      <div class="box_menu"
           :class="$Store.Page().menu.isOpen?'active':''"
           :style="{maxHeight:`${$Store.Public().height-60}px`}">
        <a-row justify="end">
          <a-col :xs="24" :xl="13">
            <a-menu :mode="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'horizontal':'inline'"
                    :inlineIndent="35" :subMenuCloseDelay="0.3" :selectable="false">
              <template v-for="(item,index) in $Store.Page().menu.list">
                <template v-if="item.icon">
                  <a-menu-item :key="index" style="width: 32px;">
                    <a :class="{point:item.point}">
                      <GithubOutlined style="fontSize:18px" @click="localTo(item.href)" />
                      <span style="color:white !important;margin: 0 5px;">|</span>
                    </a>
                  </a-menu-item>
                </template>
                <a-sub-menu v-else-if="item.children!==undefined"
                            :key="`${index}_sub`" :disabled="item.children.length===0">
                  <template #title>
                    <a :class="{point:item.point}">
                      {{ item.name }}
                    </a>
                  </template>
                  <template v-for="(v,i) in item.children">
                    <a-sub-menu v-if="v.children!==undefined"
                                :key="`${index}_${i}_sub`" :disabled="v.children.length===0">
                      <template #title>
                        <a>{{ v.name }}</a>
                      </template>
                      <a-menu-item v-for="(vv,ii) in v.children"
                                   :key="`${index}_${i}_${ii}`">
                        <a v-if="vv.type===enumType.menu.Doc" target="_blank"
                           :href="vv.href">
                          <i class="iconfont" :class="`icon-${vv.name.toLowerCase()}`" />
                          {{ vv.name }}
                          <CaretRightOutlined />
                        </a>
                        <router-link v-else-if="vv.type===enumType.menu.Book"
                                     :to="vv.href" target="_blank">
                          {{ vv.name }}
                          <CaretRightOutlined />
                        </router-link>
                        <a v-else target="_blank"
                           :href="vv.href">
                          {{ vv.name }}
                          <!--   <CaretRightOutlined /> -->
                        </a>
                      </a-menu-item>
                    </a-sub-menu>
                    <a-menu-item v-else
                                 :key="`${index}_${i}`">
                      <Link :name="v.name" :point="v.point"
                            :href="v.href+(v.hash?`#${v.hash}`:'')"
                            :click="v.click" />
                    </a-menu-item>
                  </template>
                </a-sub-menu>
                <a-menu-item v-else
                             :key="index.toString()" :disabled="item.href===undefined&&item.click===undefined">
                  <Link :class="{point:item.point}"
                        :name="item.name" :icon="item.icon"
                        :href="item.href"
                        :click="item.click" />
                </a-menu-item>
              </template>
            </a-menu>
          </a-col>
          <a-col :xs="24" :xl="3">
            <div class="box_button">
              <a-button type="link" target="_blank"
                        :href="href.github">
                <span class="iconfont icon-github" />
                GitHub
              </a-button>
              <!--<a-dropdown placement="bottomRight" overlayClassName="box_dropdown"-->
              <!--            :getPopupContainer="()=>$refs.nav">-->
              <!--  <template #overlay>-->
              <!--    <a-menu>-->
              <!--      <a-menu-item>-->
              <!--        <a :href="`${$Config.Href.cloudDemo}/projects/project/113244017852022788`">-->
              <!--          应用托管平台-->
              <!--        </a>-->
              <!--      </a-menu-item>-->
              <!--      <a-menu-item>-->
              <!--        <a @click="$RQ.GoGSS()">-->
              <!--          智能运维平台-->
              <!--        </a>-->
              <!--      </a-menu-item>-->
              <!--    </a-menu>-->
              <!--  </template>-->
              <!--  <a-button type="link">-->
              <!--    体验Demo-->
              <!--  </a-button>-->
              <!--</a-dropdown>-->
              <!--<a-button type="primary" target="_blank"-->
              <!--          :href="href.gitee">-->
              <!--    <span class="iconfont icon-gitee" />-->
              <!--    Gitee-->
              <!--</a-button>-->
            </div>
          </a-col>
          <a-col :xs="24" :xl="5">
            <div class="box_other">
              <a-dropdown placement="bottomRight" overlayClassName="box_dropdown"
                          :getPopupContainer="()=>$refs.nav">
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="item in $Enum.LanguageDict">
                      <a @click="$Store.Overseas().setLanguage(item.value)">
                        {{ item.label }}
                      </a>
                    </a-menu-item>
                  </a-menu>
                </template>
                <a-button type="link" class="button_language"
                          @click.prevent>
                  {{ $Enum.LanguageDict.find(v => v.value === $Enum.LanguageEnum.ZH).label }}
                  <DownOutlined />
                </a-button>
              </a-dropdown>
              <span>|</span>
              <template v-if="!$RQ.SSO.check()">
                <a-button type="link"
                          @click="$RQ.SSO.login()">
                  注册
                </a-button>
                <span>|</span>
                <a-button type="link"
                          @click="$RQ.SSO.login()">
                  登录
                </a-button>
              </template>
              <template v-else>
                <a-dropdown placement="bottomRight" overlayClassName="box_dropdown"
                            :getPopupContainer="()=>$refs.nav">
                  <template #overlay>
                    <a-menu>
                      <a-menu-item>
                        <a target="_blank"
                           :href="$Config.Href.store">
                          AI应用市场
                        </a>
                      </a-menu-item>
                      <!-- <a-menu-item>
                        <a target="_blank"
                           :href="$Config.Href.cloud">
                          AI应用托管
                        </a>
                      </a-menu-item>-->
                      <!--<a-menu-item>-->
                      <!--  <a target="_blank"-->
                      <!--     :href="$Config.Href.dtexpress">-->
                      <!--    数据物流-->
                      <!--  </a>-->
                      <!--</a-menu-item>-->
                      <a-menu-item>
                        <a @click="logout">
                          退出登录
                        </a>
                      </a-menu-item>
                    </a-menu>
                  </template>
                  <a-button type="link" class="box_info"
                            @click.prevent>
                    {{ $Store.User().username }}
                  </a-button>
                </a-dropdown>
              </template>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" type="text/tsx">
import {
  MenuOutlined, CloseOutlined,
  DownOutlined, CaretRightOutlined, GithubOutlined
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import { MenuEnum } from '@interface/page';
import Link from '@template/page/_component/link.vue';
import ImageLogo from '@resource/image/public/logo_white.png';

export default {
  name: 'page_nav',
  components: {
    MenuOutlined,
    CloseOutlined,
    DownOutlined,
    CaretRightOutlined,
    GithubOutlined,
    Link
  },
  data(): DataInterface {
    return {
      enumType: {
        menu: MenuEnum
      },
      href: {
        github: 'https://github.com/galaxy-future',
        gitee: 'https://gitee.com/galaxy-future'
      },
      file: {
        ImageLogo
      }
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        $Store.Page().updateMenu({
          isOpen: false
        });
      }
    }
  },
  mounted(): void {
    $Store.Page().checkPointPlan();
    $Store.Page().checkPointNews();
    $Store.Page().checkPointCompany();
  },
  methods: {
    localTo(url: string) {
      const newWindow = window.open(url, '_blank');
      newWindow.focus();
    },
    /**
     * 退出登录
     */
    logout(): void {
      $RQ.SSO.logout();
      
      $FN.Message('success', {
        content: $Enum.TextEnum.SuccessLogout
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}public/';
@height: 80px;

.nav {
  @style: opacity @time, transform @time;
  .position(fixed, 0, 0, auto, 0);
  z-index: 10;
  width: 100%;
  height: @height;
  padding: 0 @padding;
  background: fade(@color_black, 70);
  border-bottom: 1px solid fade(@color_white, 20);
  opacity: 0;
  .transform(translateY(-@height));
  .transition(@style);
  
  &.active {
    opacity: 1;
    .transform(translateY(0));
  }
  
  .container {
    position: relative;
    max-width: @grid_xl;
    height: 100%;
    margin: 0 auto;
  }
}

.logo {
  .position(left);
  height: 60%;
  margin: auto 0;
  .transition(transform @time);
}

.box_menu {
  overflow: hidden;
  position: relative;
  height: @height;
  
  &:deep(.ant-menu) {
    @p: 20px;
    display: inline-block;
    width: 100%;
    height: @height;
    background: none;
    border: none;
    
    .ant-menu-item,
    .ant-menu-submenu {
      padding: 0;
      
      &:hover,
      &.ant-menu-item-active,
      &.ant-menu-submenu-active {
        > .ant-menu-title-content,
        > .ant-menu-submenu-title > .ant-menu-title-content {
          > a {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
        
        > .ant-menu-submenu-arrow,
        > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
          &::before,
          &::after {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
      }
      
      &::after {
        left: @p;
        right: @p;
        .transition(border-color @time);
      }
    }
    
    .ant-menu-title-content {
      display: block;
      height: @height;
      
      a {
        @style: color @time text-shadow @time;
        display: block;
        position: relative;
        height: @height;
        padding: 0 @p;
        .font(center, @height, @color_white, @font_6);
        .transition(@style);
        
        &::before {
          display: none;
        }
      }
    }
    
    .anticon-ellipsis {
      .font(center, @height, fade(@color_white, 90), @font_6);
    }
    
    .point {
      &::after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: @color_red;
        .transform(translate(2px, -5px));
      }
    }
  }
}

.box_button {
  position: relative;
  height: @height;
  
  .ant-btn {
    @bw: 110px;
    @bh: 34px;
    @style: color @time, opacity @time;
    .position();
    width: @bw;
    height: @bh;
    padding: 0;
    margin: auto;
    .transition(@style);
    border: 1px solid @color_white;
    border-radius: @bh*0.5;
    background-color: transparent;
    .font(center, -1px+@bh, @color_white, @font_6);
    .borderBox();
    
    // &:nth-child(1) {
    //   left: -@bw;
    //   border-radius: 5px 0 0 5px;
    //   border-right: 1px solid fade(@color_black, 10);
    //   background-color: transparent;
    //   .font(center, -1px+@bh, @color_white, @font_6);
    // }
    //
    // &:nth-child(2) {
    //   right: -@bw;
    //   border-radius: 0 5px 5px 0;
    //   border-left: 1px solid fade(@color_black, 10);
    //   background-color: @color_white;
    //   .font(center, -1px+@bh, @color_6, @font_6);
    // }
    
    &:hover {
      opacity: 0.8;
    }
    
    span {
      margin-right: 5px;
    }
  }
}

.box_other {
  @h: 34px;
  display: flex;
  align-items: center;
  position: relative;
  height: @height;
  
  span,
  .ant-btn:deep(span) {
    display: inline-block;
    .font(center, @h, @color_white, @font_6);
  }
  
  .ant-btn {
    flex: 1;
    height: auto;
    padding: 0;
    border: none;
    
    &.ant-dropdown-open {
      .anticon {
        &:deep(svg) {
          .transform(translateY(2px) scaleY(-1));
        }
      }
    }
    
    &:hover {
      &:deep(span) {
        color: @color_processing;
      }
    }
    
    &:deep(span) {
      .transition(color @time);
    }
    
    .anticon {
      margin: 0 0 0 3px;
      .font(center, @h, @color_white, @font_8);
      vertical-align: top;
      
      &:deep(svg) {
        .transform(translateY(2px));
        .transition(transform @time);
      }
    }
  }
  
  .box_info {
    overflow: hidden;
    flex: 3;
    .font(center, @h, @color_white, @font_6);
    
    &:deep(span) {
      display: block;
      max-width: 100%;
      padding: 0 10px;
      .ellipsis();
    }
  }
  
  .button_language {
    flex: 2;
  }
}

.button_menu {
  @ms: 40px;
  .position(right);
  width: @ms;
  height: @ms;
  margin: auto 0;
  background: fade(@color_black, 30);
  border: 1px solid fade(@color_white, 20);
  border-radius: 5px;
  cursor: pointer;
  .transition(opacity @time);
  
  &:hover {
    opacity: @opacity;
  }
  
  span {
    @as: 26px;
    .position();
    width: @ms;
    height: @ms;
    margin: auto;
    .font(center, @ms, fade(@color_white, 70), @as);
    opacity: 0;
    .transform(translateX(-1px));
    .transition(opacity @time);
    
    &.active {
      opacity: 1;
    }
    
    &:deep(svg) {
      display: block;
      .position();
      margin: auto;
    }
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  @height: 60px;
  
  .nav {
    height: @height;
    padding: 0 10px;
    opacity: 1 !important;
    .transform(translateY(0)) !important;
  }
  
  .box_menu {
    @style: opacity @time, transform @time;
    @mh: 40px;
    overflow-x: hidden;
    overflow-y: auto;
    .position(absolute, @height, -10px, auto, -10px);
    width: calc(~'100% + 20px');
    height: auto;
    padding: 20px 0;
    background: fade(@color_black, 85);
    opacity: 0;
    .transform(translateX(100%));
    .transition(@style);
    pointer-events: none;
    
    &.active {
      opacity: 1;
      .transform(translateX(0));
      pointer-events: all;
    }
    
    &:deep(.ant-menu) {
      height: auto;
      
      .ant-menu-item,
      .ant-menu-submenu {
        padding: 0 !important;
        margin: 0;
        
        &::after {
          display: none;
        }
      }
      
      .ant-menu-title-content {
        height: @mh;
        
        a {
          height: @mh;
          padding: 0 0 0 20px;
          .font(left, @mh, @color_white, @font_6);
        }
        
        .anticon {
          .position(right, 20px);
          height: 14px;
          margin: auto 0;
          .transition(color 0s);
        }
      }
      
      .ant-menu-submenu-title {
        padding: 0 !important;
        margin: 0;
        
        .ant-menu-submenu-arrow {
          right: 20px;
          
          &::before,
          &::after {
            color: @color_white !important;
          }
        }
      }
      
      .ant-menu-sub {
        padding: 0 0 5px;
        background: fade(@color_black, 30);
        
        a {
          padding: 0 0 0 40px;
        }
        
        .ant-menu-sub {
          background: fade(@color_black, 60);
          
          a {
            padding: 0 0 0 60px;
          }
        }
      }
    }
  }
  
  .box_button {
    height: @height;
    margin-top: 10px;
    
    .ant-btn {
      width: calc(~'100% - 40px');
      
      // &:nth-child(1) {
      //   left: 20px;
      //   right: auto;
      // }
      //
      // &:nth-child(2) {
      //   left: auto;
      //   right: 20px;
      // }
    }
  }
  
  .box_other {
    height: @height;
    
    .box_info {
      flex: 1;
    }
    
    .button_language {
      flex: 1;
    }
  }
}
</style>
<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

.ant-menu-submenu-popup {
  > .ant-menu {
    background-color: fade(@color_black, 85) !important;
    border: 1px solid fade(@color_white, 20) !important;
    .borderBox() !important;
    
    .ant-menu-item,
    .ant-menu-submenu {
      padding: 0 !important;
      margin: 0 !important;
      
      &:hover,
      &.ant-menu-item-active,
      &.ant-menu-submenu-active {
        > .ant-menu-title-content,
        > .ant-menu-submenu-title > .ant-menu-title-content {
          > a {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
        
        > .ant-menu-submenu-arrow,
        > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
          &::before,
          &::after {
            color: @color_processing !important;
            text-shadow: 0 0 1px @color_processing !important;
          }
        }
      }
    }
    
    .ant-menu-title-content {
      display: block;
      height: 100%;
      
      a {
        @style: color @time text-shadow @time;
        display: block;
        position: relative;
        height: 100%;
        padding: 0 10px;
        color: fade(@color_white, 90);
        .transition(@style);
        
        &::before {
          display: none;
        }
      }
      
      .anticon {
        .position(right, 10px);
        height: 14px;
        margin: auto 0;
        .transition(color 0s);
      }
    }
    
    .ant-menu-submenu-title {
      padding: 0 !important;
      margin: 0 !important;
      
      .ant-menu-submenu-arrow {
        right: 10px;
        
        &::before,
        &::after {
          color: @color_white;
        }
      }
    }
    
    .point {
      &::after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: @color_red;
        .transform(translate(2px, -5px));
      }
    }
  }
}

.box_dropdown {
  .ant-dropdown-menu {
    background-color: fade(@color_black, 85);
    border: 1px solid fade(@color_white, 20);
    .borderBox();
    
    .ant-dropdown-menu-item {
      min-width: 100px;
      color: fade(@color_white, 90);
      
      &:hover {
        color: @color_processing;
        background-color: fade(@color_black, 85);
      }
    }
  }
}
</style>